var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;fill-opacity:0;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#FFFFFF;}\n\t.st2{fill:none;}\n\t.st3{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-\u5BA1\u8BA1\u4E2D\u5FC3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u4F18\\u5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-338, -40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-\\u5BA1\\u8BA1\\u4E2D\\u5FC3",
    transform: "translate(336, 39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 2,
    y: 1,
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_1_",
    x: 4.5,
    y: 14.5,
    className: "st1",
    width: 11,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    className: "st2",
    d: "M10,2c1.7,0,3,1.3,3,3c0,0.9-0.4,1.7-1,2.2L12,8c0,0.6,0.4,1,1,1h2c0.6,0,1,0.4,1,1v3H4 v-3c0-0.6,0.4-1,1-1h2c0.6,0,1-0.4,1-1l0-0.8C7.4,6.7,7,5.9,7,5C7,3.3,8.3,2,10,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408_1_",
    className: "st3",
    d: "M10,2c1.7,0,3,1.3,3,3c0,0.9-0.4,1.7-1,2.2L12,8c0,0.6,0.4,1,1,1h2c0.6,0,1,0.4,1,1v3 H4v-3c0-0.6,0.4-1,1-1h2c0.6,0,1-0.4,1-1l0-0.8C7.4,6.7,7,5.9,7,5C7,3.3,8.3,2,10,2z M10,3C8.9,3,8,3.9,8,5 c0,0.6,0.2,1.1,0.7,1.5L9,6.8L9,8c0,1.1-0.9,2-2,2H5v2h10v-2h-2c-1.1,0-2-0.9-2-2l0-0.8l0-0.4l0.3-0.3C11.8,6.1,12,5.6,12,5 C12,3.9,11.1,3,10,3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditCenter);
export default __webpack_public_path__ + "static/media/audit-center.1fbf8ae3ce8d664c967634767d3fd652.svg";
export { ForwardRef as ReactComponent };